import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'hooks/useTranslation';

const ModalAddWebsiteFooter = ({ toggle, handleAddNewWebsite }) => {
  const { getTranslation } = useTranslation("WEBSITES");
  const { t } = getTranslation();

  return (
    <div className='modal__container__footer__left'>
      <a
        href='#/'
        onClick={toggle}
        className='btn btn-tertiary'
        id='closeModal'
      >
        {t("MODAL").CANCEL}
      </a>
      <a
        href='#/'
        onClick={handleAddNewWebsite}
        className='btn btn-primary'
        id='saveClose'
      >
        {t("MODAL").ADD_WEBSITE_FOOTER_CONFIRM}
      </a>
    </div>
  );
};

ModalAddWebsiteFooter.propTypes = {
  toggle: PropTypes.func.isRequired,
  handleAddNewWebsite: PropTypes.func.isRequired,
};

export default ModalAddWebsiteFooter;
